var map = {
	"./blue/nav/history.svg": 9506,
	"./blue/nav/home.svg": 1688,
	"./blue/nav/print.svg": 9772,
	"./blue/nav/report-final.svg": 2842,
	"./blue/nav/report.svg": 3339,
	"./blue/nav/result.svg": 6532,
	"./blue/nav/scan.svg": 7947,
	"./darkblue/nav/history.svg": 7422,
	"./darkblue/nav/home.svg": 5429,
	"./darkblue/nav/print.svg": 6236,
	"./darkblue/nav/report-final.svg": 4021,
	"./darkblue/nav/report.svg": 3409,
	"./darkblue/nav/result.svg": 3346,
	"./darkblue/nav/scan.svg": 6158,
	"./orange/nav/history.svg": 2933,
	"./orange/nav/home.svg": 5419,
	"./orange/nav/print.svg": 8097,
	"./orange/nav/report-final.svg": 2641,
	"./orange/nav/report.svg": 6573,
	"./orange/nav/result.svg": 860,
	"./orange/nav/scan.svg": 6068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1589;